var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('modal',{staticClass:"modal-base",attrs:{"name":_vm.WINDOW_NAME,"width":_vm.width,"height":_vm.height,"clickToClose":_vm.clickToClose,"classes":_vm.classes,"draggable":_vm.draggable,"focusTrap":true},on:{"closed":_vm.closed}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }